import { Button, Card, DatePicker } from "antd";
import Table, { ColumnsType } from "antd/lib/table";

import styles from "./index.module.less";
import Authentication from "../../util/Authentication";
import LocalStorageUtil from "../../util/LocalStorageUtil";
import { LocalStorageConstants } from "../../constants/ApplicationConstants/LocalStorageConstants";
import { Modules, Operations } from "../../constants/DatabaseConstants/MasterConstant";
import Loading from "../common/Loading";
import { TableHelper } from "../../util/TableHelper";
import { useNotification } from "./index.hook";

import type { NotificationRecord } from "../../shared/interface/Notification/index.interface";
import type { UserInterface } from "../../shared/interface/auth/User.interface";

const { RangePicker } = DatePicker;

const Notification = () => {
  /* CONSTANT */
  const userData = LocalStorageUtil.localStorageGetItem(LocalStorageConstants.USER_DATA) as UserInterface;

  /* HOOK */
  const config = useNotification();

  const columns: ColumnsType<NotificationRecord> = [
    {
      align: "left",
      title: "Sr No.",
      dataIndex: "sr_no",
      key: "sr_no",
      render: TableHelper.renderNumberValue,
      sorter: {
        compare: TableHelper.valueCompare("sr_no")
      },
      width: "5%"
    },
    {
      align: "left",
      title: "Type",
      dataIndex: "notification_endpoint_type",
      key: "notification_endpoint_type",
      render: TableHelper.renderTextContainer,
      sorter: {
        compare: TableHelper.valueCompare("notification_endpoint_type")
      },
      width: "10%"
    },
    {
      align: "left",
      title: "Send To",
      dataIndex: "notificationSend",
      key: "notificationSend",
      render: TableHelper.renderTextContainer,
      sorter: {
        compare: TableHelper.valueCompare("notificationSend")
      },
      width: "10%"
    },
    {
      align: "left",
      title: "Template",
      dataIndex: "notificationKey",
      key: "notificationKey",
      render: TableHelper.renderTextContainer,
      sorter: {
        compare: TableHelper.valueCompare("notificationKey")
      },
      width: "15%"
    },
    {
      align: "left",
      title: "Subject",
      dataIndex: "notification_subject",
      key: "notification_subject",
      render: TableHelper.renderTextContainer,
      sorter: {
        compare: TableHelper.valueCompare("notification_subject")
      },
      width: "10%"
    },
    {
      align: "left",
      title: "Message",
      dataIndex: "notification_message",
      key: "notification_message",
      render: TableHelper.renderTextContainer,
      sorter: {
        compare: TableHelper.valueCompare("notification_message")
      }
    },
    {
      align: "left",
      title: "Publish On",
      dataIndex: "publishOn",
      key: "publishOn",
      render: TableHelper.renderNumberValue,
      sorter: {
        compare: TableHelper.dateSorter("publishOn")
      },
      width: "12%"
    },
    {
      align: "left",
      title: "Created On",
      dataIndex: "createdOn",
      key: "createdOn",
      render: TableHelper.renderNumberValue,
      sorter: {
        compare: TableHelper.dateSorter("createdOn")
      },
      width: "12%"
    }
  ];

  return (
    <Card
      className="gx-card card--height"
      title={
        <div className={`gx-title-container`}>
          <div className="card-title-style">Messaging</div>

          <div className={`gx-title-right-section`}>
            {/* DatePicker */}
            <div className={styles["right-section-filter"]}>
              <RangePicker getPopupContainer={(trigger) => trigger.parentElement || document.body} format="DD-MM-YYYY" style={{ width: "100%" }} onChange={config.handleChangeDatePicker} />
              <Button className={`button-gradiant gx-mb-0 gx-mr-0 `} onClick={config.handleGo}>
                Go
              </Button>
            </div>
            {Authentication.hasModuleAndOperationAccess(userData, Modules.MESSAGING, Operations.CREATE) && (
              <Button onClick={config.handleAddClick} disabled={!config?.customerId || !config?.locationId} className={`button-gradiant gx-mb-0 gx-mr-0 add-button`}>
                Add Messaging
              </Button>
            )}
          </div>
        </div>
      }
    >
      {config.loading && <Loading />}

      {!config.loading && Authentication.hasModuleAndOperationAccess(userData, Modules.MESSAGING, Operations.READ) && <Table className="gx-table-responsive" size="small" columns={columns} dataSource={config.notificationList} pagination={config?.pagination} bordered onChange={config.handleChangePagination} rowKey={(record) => record.sr_no} />}
    </Card>
  );
};

export default Notification;
